import PropTypes from 'prop-types';
import React from 'react';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';

export class InputField extends React.Component {
  render() {
    const {
      suppressErrorMessage,
      suppressSuccessMessage,
      forceErrorState,
      showSubmitErrorWhenActive,
      id,
      inputAttributes,
      inputClassNames,
      inputTag = 'input',
      label,
      input,
      meta,
      type,
      wrapperAttributes,
      wrapperTag,
      isDisabled = false,
      children,
    } = this.props;

    const fieldId = id || `${input.name}_field`;
    const shouldShowActiveError = showSubmitErrorWhenActive && meta.submitFailed;
    const hasError = forceErrorState || (meta.error && meta.touched && (!meta.active || shouldShowActiveError));
    const classes = [];

    if (hasError) {
      classes.push('form__input--error');
    } else if (!suppressSuccessMessage && meta.touched && !meta.active && inputTag === 'input' && input.value) {
      classes.push('form__input--valid');
    }

    if (inputClassNames) {
      classes.push(inputClassNames);
    }

    if (inputAttributes && inputAttributes.onBlur) {
      const onBlurFn = inputAttributes.onBlur;
      inputAttributes.onBlur = function composedBlur(event) {
        input.onBlur(event);
        return onBlurFn.call(this, event);
      };
    }

    const firstChild = React.Children.toArray(children)[0];
    const firstChildIsOption = firstChild && firstChild.type === 'option';

    const inputElement = React.createElement(
      inputTag,
      {
        className: classes.join(' '),
        type: type || 'text',
        id: fieldId,
        disabled: isDisabled,
        ...input,
        ...inputAttributes,
      },
      firstChildIsOption && children
    );

    let inputAndLabelElements = [label ? <label htmlFor={fieldId}>{label}</label> : null, inputElement];

    // If we are a checkbox, show the input BEFORE the label
    if (inputAttributes && inputAttributes.type === 'checkbox') {
      inputAndLabelElements = [inputAndLabelElements[1], inputAndLabelElements[0]];
    }

    const errorElement = !hasError || suppressErrorMessage ? undefined : <LocalizableMessage message={meta.error} />;

    return React.createElement(
      wrapperTag || 'div',
      wrapperAttributes || {},
      ...inputAndLabelElements,
      errorElement ? (
        <div className="error__text text--sm mt-" data-cypress="form-input-error">
          {errorElement}
        </div>
      ) : null,
      !firstChildIsOption && children
    );
  }
}

InputField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  children: PropTypes.node,
  isDisabled: PropTypes.bool,
  id: PropTypes.string,
  inputClassNames: PropTypes.string,
  inputAttributes: PropTypes.object,
  inputTag: PropTypes.string,
  label: PropTypes.element,
  type: PropTypes.string,
  forceErrorState: PropTypes.bool,
  /**
   * When set, `showSubmitErrorWhenActive` will ensure the component always
   * displays post-submit validation errors, even when the input field is
   * currently focused ("active" in redux-form terminology).
   *
   * See this issue for context and clean-up TODOs:
   * https://classpass.atlassian.net/browse/CRO-2087
   */
  showSubmitErrorWhenActive: PropTypes.bool,
  suppressErrorMessage: PropTypes.bool,
  suppressSuccessMessage: PropTypes.bool,
  wrapperAttributes: PropTypes.object,
  wrapperTag: PropTypes.string,
};
